module.exports = __webpack_public_path__ + "static/media/check.85b14b12.svg";